"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function replacePageParam(page, inputString) {
  if (!inputString || !inputString.length) return;
  return inputString.replace('<PAGE>', "".concat(page));
}
var _default = replacePageParam;
exports["default"] = _default;